import React from "react";
import { PropTypes } from "prop-types";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { withI18n } from "../../../../i18n/useI18n";
import * as actions from "../actions";
import css from "../trendAnalysisMagneticStyle.less";

import AppHoc from "../../../../generics/AppHOC";
import TimeFilter from "../../../../generics/TimeFilter";
import TimeStamp from "../../../../generics/TimeStamp";

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

const mapStateToProps = state => ({
  trend: state.vanalytics.trend
});

class FilterView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { tViews } = this.props.i18n;
    
    return (
      <div className={css.ctrlDashlet} data-cy="trendFilter">
        <div className="custom-actions">
          <div className="time-filter application-trend-timefilter">
            <TimeFilter sideBar={true} />
          </div>
          <div className="hbr-type-body4 application-trend-time-stamp">
            <TimeStamp sideBar={true}  hideCompareText={true} {...this.props} />
          </div>
        </div>
        <div className="hbr-type-h1 application-trend-title" data-cy="trend-title">
          {tViews('overallTrendViewOverall')}
        </div>
      </div>
    );
  }
}

FilterView.propTypes = {
  actions: PropTypes.object.isRequired,
  trend: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AppHoc(withI18n(FilterView)))
);
